import type { Video as VideoType } from '@/blocks/video';

import { VimeoEmbed } from '../Primitive/VimeoEmbed/VimeoEmbed';
import { YoutubeEmbed } from '../Primitive/YoutubeEmbed/YoutubeEmbed';

interface VideoProps {
  block: VideoType;
}

export const VideoBlock = ({ block }: VideoProps) => {
  return (
    <div className="flex aspect-video w-full">
      {block.videoType === 'vimeo' ? (
        <VimeoEmbed id={block.videoId} />
      ) : (
        <YoutubeEmbed id={block.videoId} />
      )}
    </div>
  );
};
